import { useQuery } from "react-query";
import { getMGAList } from "../../../../actions/Utilities/MGA/index";
export const useGetMGA = () => {
  return useQuery("getMGAListProducerCode", getMGAList, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
